<div class="arrow-wrap">
  <div class="arrow" [ngClass]="arrowConfig[1] + ' ' + arrowConfig[1] + '-' + arrowConfig[0]"></div>
  <div class="walkthrough-tooltip" [ngClass]="arrowConfig[0]">
    <div>
      <div class="header">
        <div layout layout-align-items-center>
          @if (hasNewBadge) {
            <rt-badge color="pink" [text]="'app.common.new' | translate" margin-right-small-x />
          }
          <div class="headline">{{ heading }}</div>
        </div>
        <rt-icon-button
          variant="transparent-light"
          iconName="close"
          iconColor="colorIconOnboardingLowDefault"
          size="small"
          (click)="closeTooltip()"
        ></rt-icon-button>
      </div>
      <div class="description" [innerHTML]="description"></div>
    </div>
    @if (ctaText) {
      <div class="footer">
        @if (showStepCounter) {
          <div class="step-counter">{{ currentStep }} {{ ofText }} {{ stepsTotal }}</div>
        }
        <div class="actions-container">
          <rt-button class="main-action" variant="tertiary" (click)="next.emit()">
            <span>{{ ctaText }}</span>
            @if (ctaIcon) {
              <rt-icon [name]="ctaIcon"></rt-icon>
            }
          </rt-button>
        </div>
      </div>
    }
  </div>
</div>
